import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const invitationContract = c.router({
  generateInvitationUrl: {
    method: 'POST',
    path: '/invitation/generate-invitation-url',
    body: z.object({ email: z.string().email() }),
    responses: { 200: z.object({ invitationUrl: z.string() }) },
  },
  sendInvite: {
    method: 'POST',
    path: '/invitation/send-invite',
    body: z.object({ email: z.string().email() }),
    responses: { 200: z.object({ success: z.boolean() }) },
  },
});
